import type { 
    ICoreDataService, 
    ExpediteDataResponse, 
    ExpediteCreateRequestList, 
    ExpediteCreateResponse, 
    QuoteReasonCodeDataResponse, 
    QuoteReasonCodeCreateRequestList, 
    QuoteReasonCodeCreateResponse,
    CarrierDataResponse,
    CarrierCreateRequestList,
    CarrierCreateResponse,
    EquipmentDataResponse,
    EquipmentCreateRequestList,
    EquipmentCreateResponse,
    HandlingUnitDataResponse,
    HandlingUnitCreateRequestList,
    HandlingUnitCreateResponse,
    OrderReleaseTypeDataResponse,
    OrderReleaseTypeCreateRequestList,
    OrderReleaseTypeCreateResponse,
    TransportModeDataResponse,
    TransportModeCreateRequestList,
    TransportModeCreateResponse,
    OTMContactData,
    OTMContactDataResponse,
    OTMContactCreateRequestList,
    OTMContactCreateResponse,
    OTMContactUpdateRequestList,
    OTMContactUpdateResponse,
    OTMContactDeleteResponse,
    OTMContactComMethodData,
    OTMContactComMethodDataResponse,
    OTMContactComMethodCreateRequestList,
    OTMContactComMethodCreateResponse,
    OTMContactComMethodUpdateRequestList,
    OTMContactComMethodUpdateResponse,
    OTMContactComMethodDeleteResponse,
    OTMXLaneData,
    OTMXLaneDataResponse,
    OTMXLaneCreateRequestList,
    OTMXLaneCreateResponse,
    OTMXLaneUpdateRequestList,
    OTMXLaneUpdateResponse,
    OTMXLaneDeleteResponse,
    OTMServiceProviderData,
    OTMServiceProviderDataResponse,
    OTMServiceProviderCreateRequestList,
    OTMServiceProviderCreateResponse,
    OTMServiceProviderUpdateRequestList,
    OTMServiceProviderUpdateResponse,
    OTMServiceProviderDeleteResponse,
    OTMServProvProfileData,
    OTMServProvProfileDataResponse,
    OTMServProvProfileCreateRequestList,
    OTMServProvProfileCreateResponse,
    OTMServProvProfileUpdateRequestList,
    OTMServProvProfileUpdateResponse,
    OTMServProvProfileDeleteResponse,
    OTMItemData,
    OTMItemDataResponse,
    OTMItemCreateRequestList,
    OTMItemCreateResponse,
    OTMItemUpdateRequestList,
    OTMItemUpdateResponse,
    OTMItemDeleteResponse,
    OTMPackagedItemData,
    OTMPackagedItemDataResponse,
    OTMPackagedItemCreateRequestList,
    OTMPackagedItemCreateResponse,
    OTMPackagedItemUpdateRequestList,
    OTMPackagedItemUpdateResponse,
    OTMPackagedItemDeleteResponse,
    OTMEquipmentGroupProfileData,
    OTMEquipmentGroupProfileDataResponse,
    OTMEquipmentGroupProfileCreateRequestList,
    OTMEquipmentGroupProfileCreateResponse,
    OTMEquipmentGroupProfileUpdateRequestList,
    OTMEquipmentGroupProfileUpdateResponse,
    OTMEquipmentGroupProfileDeleteResponse,
    OTMEquipmentGroupProfileDData,
    OTMEquipmentGroupProfileDDataResponse,
    OTMEquipmentGroupProfileDCreateRequestList,
    OTMEquipmentGroupProfileDCreateResponse,
    OTMEquipmentGroupProfileDUpdateRequestList,
    OTMEquipmentGroupProfileDUpdateResponse,
    OTMEquipmentGroupProfileDDeleteResponse,
    OTMModeProfileData,
    OTMModeProfileDataResponse,
    OTMModeProfileCreateRequestList,
    OTMModeProfileCreateResponse,
    OTMModeProfileUpdateRequestList,
    OTMModeProfileUpdateResponse,
    OTMModeProfileDeleteResponse,
    OTMModeProfileDetailData,
    OTMModeProfileDetailDataResponse,
    OTMModeProfileDetailCreateRequestList,
    OTMModeProfileDetailCreateResponse,
    OTMModeProfileDetailUpdateRequestList,
    OTMModeProfileDetailUpdateResponse,
    OTMModeProfileDetailDeleteResponse,
    GlKeyComponentData,
    GlKeyComponentDataResponse,
    GlKeyComponentCreateRequestList,
    GlKeyComponentCreateResponse,
    GlKeyComponentUpdateRequestList,
    GlKeyComponentUpdateResponse,
    GlKeyComponentDeleteResponse,
    GlKeyComponentParamData,
    GlKeyComponentParamDataResponse,
    GlKeyComponentParamCreateRequestList,
    GlKeyComponentParamCreateResponse,
    GlKeyComponentParamUpdateRequestList,
    GlKeyComponentParamUpdateResponse,
    GlKeyComponentParamDeleteResponse,
    GlLookupKeyData,
    GlLookupKeyDataResponse,
    GlLookupKeyCreateRequestList,
    GlLookupKeyCreateResponse,
    GlLookupKeyUpdateRequestList,
    GlLookupKeyUpdateResponse,
    GlLookupKeyDeleteResponse,
    GlLookupKeyDData,
    GlLookupKeyDDataResponse,
    GlLookupKeyDCreateRequestList,
    GlLookupKeyDCreateResponse,
    GlLookupKeyDUpdateRequestList,
    GlLookupKeyDUpdateResponse,
    GlLookupKeyDDeleteResponse,
    GeneralLedgerCodeData,
    GeneralLedgerCodeDataResponse,
    GeneralLedgerCodeCreateRequestList,
    GeneralLedgerCodeCreateResponse,
    GeneralLedgerCodeUpdateRequestList,
    GeneralLedgerCodeUpdateResponse,
    GeneralLedgerCodeDeleteResponse,
    GLCodeMapData,
    GLCodeMapDataResponse,
    GLCodeMapCreateRequestList,
    GLCodeMapCreateResponse,
    GLCodeMapUpdateRequestList,
    GLCodeMapUpdateResponse,
    GLCodeMapDeleteResponse,
    MessageCodeMapData,
    MessageCodeMapDataResponse,
    MessageCodeMapCreateRequestList,
    MessageCodeMapCreateResponse,
    MessageCodeMapUpdateRequestList,
    MessageCodeMapUpdateResponse,
    MessageCodeMapDeleteResponse,
    MessageCodeMapDData,
    MessageCodeMapDDataResponse,
    MessageCodeMapDCreateRequestList,
    MessageCodeMapDCreateResponse,
    MessageCodeMapDUpdateRequestList,
    MessageCodeMapDUpdateResponse,
    MessageCodeMapDDeleteResponse,
    SpecialServiceProfileData,
    SpecialServiceProfileDataResponse,
    SpecialServiceProfileCreateRequestList,
    SpecialServiceProfileCreateResponse,
    SpecialServiceProfileUpdateRequestList,
    SpecialServiceProfileUpdateResponse,
    SpecialServiceProfileDeleteResponse,
    SpecialServiceProfileDData,
    SpecialServiceProfileDDataResponse,
    SpecialServiceProfileDCreateRequestList,
    SpecialServiceProfileDCreateResponse,
    SpecialServiceProfileDUpdateRequestList,
    SpecialServiceProfileDUpdateResponse,
    SpecialServiceProfileDDeleteResponse,
    ShipUnitSpecProfileData,
    ShipUnitSpecProfileDataResponse,
    ShipUnitSpecProfileCreateRequestList,
    ShipUnitSpecProfileCreateResponse,
    ShipUnitSpecProfileUpdateRequestList,
    ShipUnitSpecProfileUpdateResponse,
    ShipUnitSpecProfileDeleteResponse,
    ShipUnitSpecProfileDData,
    ShipUnitSpecProfileDDataResponse,
    ShipUnitSpecProfileDCreateRequestList,
    ShipUnitSpecProfileDCreateResponse,
    ShipUnitSpecProfileDUpdateRequestList,
    ShipUnitSpecProfileDUpdateResponse,
    ShipUnitSpecProfileDDeleteResponse,
    WorkflowParamData,
    WorkflowParamDataResponse,
    WorkflowParamCreateRequestList,
    WorkflowParamCreateResponse,
    WorkflowParamUpdateRequestList,
    WorkflowParamUpdateResponse,
    WorkflowParamDeleteResponse,
    ShipUnitSpecData,
    ShipUnitSpecDataResponse,
    ShipUnitSpecCreateRequestList,
    ShipUnitSpecCreateResponse,
    ShipUnitSpecUpdateRequestList,
    ShipUnitSpecUpdateResponse,
    ShipUnitSpecDeleteResponse,
    TextTemplateData,
    TextTemplateDataResponse,
    TextTemplateCreateRequestList,
    TextTemplateCreateResponse,
    TextTemplateUpdateRequestList,
    TextTemplateUpdateResponse,
    TextTemplateDeleteRequest,
    TextTemplateDeleteResponse,
    OTMItineraryDataResponse,
    OTMItineraryData,
    OTMItineraryCreateRequestList,
    OTMItineraryCreateResponse,
    OTMItineraryUpdateRequestList,
    OTMItineraryUpdateResponse,
    OTMItineraryDeleteResponse,
    OTMItineraryDetailData,
    OTMItineraryDetailDataResponse,
    OTMItineraryDetailCreateRequestList,
    OTMItineraryDetailCreateResponse,
    OTMItineraryDetailUpdateRequestList,
    OTMItineraryDetailUpdateResponse,
    OTMItineraryDetailDeleteResponse,
    OTMItineraryLegData,
    OTMItineraryLegDataResponse,
    OTMItineraryLegCreateRequestList,
    OTMItineraryLegCreateResponse,
    OTMItineraryLegUpdateRequestList,
    OTMItineraryLegUpdateResponse,
    OTMItineraryLegDeleteResponse
} from '../interface/ICoreDataService';
import type { IHttpWrapperService } from '../interface/IHttpWrapperService';
import { container, TYPES } from '../inversify.config';
import type { AxiosResponse } from 'axios';
import type { ApiResponse } from '../../models/ApiResponse';
import { isSuccessResponse } from '../../models/ApiResponse';

export class CoreDataService implements ICoreDataService {
    private httpService: IHttpWrapperService = container.get(TYPES.IHttpWrapperService);

    async GetExpediteData(pageNumber: number, pageSize: number, partnerCode: string): Promise<ExpediteDataResponse> {
        try {
            const endpoint = `coredata/expedite/getall?pageNumber=${pageNumber}&pageSize=${pageSize}&partnerCode=${partnerCode}`;
            const response: AxiosResponse<ApiResponse<{ items: any[]; totalCount: number }>> = 
                await this.httpService.getRequest<{ items: any[]; totalCount: number }>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: null
                };
            } else {
                throw new Error(response.data.message || 'Failed to fetch expedite data');
            }
        } catch (error) {
            throw error;
        }
    }

    async CreateExpediteData(request: ExpediteCreateRequestList): Promise<ExpediteCreateResponse> {
        try {
            const endpoint = 'coredata/expedite/create';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.postRequest<boolean, ExpediteCreateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to create expedite data');
            }
        } catch (error) {
            throw error;
        }
    }

    async GetQuoteReasonCodeData(pageNumber: number, pageSize: number, partnerCode: string): Promise<QuoteReasonCodeDataResponse> {
        try {
            const endpoint = `coredata/quotereasoncode/getall?pageNumber=${pageNumber}&pageSize=${pageSize}&partnerCode=${partnerCode}`;
            const response: AxiosResponse<ApiResponse<{ items: any[]; totalCount: number }>> = 
                await this.httpService.getRequest<{ items: any[]; totalCount: number }>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: null
                };
            } else {
                throw new Error(response.data.message || 'Failed to fetch quote reason code data');
            }
        } catch (error) {
            throw error;
        }
    }

    async CreateQuoteReasonCodeData(request: QuoteReasonCodeCreateRequestList): Promise<QuoteReasonCodeCreateResponse> {
        try {
            const endpoint = 'coredata/quotereasoncode/create';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.postRequest<boolean, QuoteReasonCodeCreateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to create quote reason code data');
            }
        } catch (error) {
            throw error;
        }
    }

    async GetCarrierData(pageNumber: number, pageSize: number, partnerCode: string): Promise<CarrierDataResponse> {
        try {
            const endpoint = `coredata/carrier/getall?pageNumber=${pageNumber}&pageSize=${pageSize}&partnerCode=${partnerCode}`;
            const response: AxiosResponse<ApiResponse<{ items: any[]; totalCount: number }>> = 
                await this.httpService.getRequest<{ items: any[]; totalCount: number }>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: null
                };
            } else {
                throw new Error(response.data.message || 'Failed to fetch carrier data');
            }
        } catch (error) {
            throw error;
        }
    }

    async CreateCarrierData(request: CarrierCreateRequestList): Promise<CarrierCreateResponse> {
        try {
            const endpoint = 'coredata/carrier/create';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.postRequest<boolean, CarrierCreateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to create carrier data');
            }
        } catch (error) {
            throw error;
        }
    }

    async GetEquipmentData(pageNumber: number, pageSize: number, partnerCode: string): Promise<EquipmentDataResponse> {
        try {
            const endpoint = `coredata/equipment/getall?pageNumber=${pageNumber}&pageSize=${pageSize}&partnerCode=${partnerCode}`;
            const response: AxiosResponse<ApiResponse<{ items: any[]; totalCount: number }>> = 
                await this.httpService.getRequest<{ items: any[]; totalCount: number }>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: null
                };
            } else {
                throw new Error(response.data.message || 'Failed to fetch equipment data');
            }
        } catch (error) {
            throw error;
        }
    }

    async CreateEquipmentData(request: EquipmentCreateRequestList): Promise<EquipmentCreateResponse> {
        try {
            const endpoint = 'coredata/equipment/create';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.postRequest<boolean, EquipmentCreateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to create equipment data');
            }
        } catch (error) {
            throw error;
        }
    }

    async GetHandlingUnitData(pageNumber: number, pageSize: number, partnerCode: string): Promise<HandlingUnitDataResponse> {
        try {
            const endpoint = `coredata/handlingunit/getall?pageNumber=${pageNumber}&pageSize=${pageSize}&partnerCode=${partnerCode}`;
            const response: AxiosResponse<ApiResponse<{ items: any[]; totalCount: number }>> = 
                await this.httpService.getRequest<{ items: any[]; totalCount: number }>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: null
                };
            } else {
                throw new Error(response.data.message || 'Failed to fetch handling unit data');
            }
        } catch (error) {
            throw error;
        }
    }

    async CreateHandlingUnitData(request: HandlingUnitCreateRequestList): Promise<HandlingUnitCreateResponse> {
        try {
            const endpoint = 'coredata/handlingunit/create';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.postRequest<boolean, HandlingUnitCreateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to create handling unit data');
            }
        } catch (error) {
            throw error;
        }
    }

    async GetOrderReleaseTypeData(pageNumber: number, pageSize: number, partnerCode: string): Promise<OrderReleaseTypeDataResponse> {
        try {
            const endpoint = `coredata/orderreleasetype/getall?pageNumber=${pageNumber}&pageSize=${pageSize}&partnerCode=${partnerCode}`;
            const response: AxiosResponse<ApiResponse<{ items: any[]; totalCount: number }>> = 
                await this.httpService.getRequest<{ items: any[]; totalCount: number }>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: null
                };
            } else {
                throw new Error(response.data.message || 'Failed to fetch order release type data');
            }
        } catch (error) {
            throw error;
        }
    }

    async CreateOrderReleaseTypeData(request: OrderReleaseTypeCreateRequestList): Promise<OrderReleaseTypeCreateResponse> {
        try {
            const endpoint = 'coredata/orderreleasetype/create';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.postRequest<boolean, OrderReleaseTypeCreateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to create order release type data');
            }
        } catch (error) {
            throw error;
        }
    }

    async GetTransportModeData(pageNumber: number, pageSize: number, partnerCode: string): Promise<TransportModeDataResponse> {
        try {
            const endpoint = `coredata/transportmode/getall?pageNumber=${pageNumber}&pageSize=${pageSize}&partnerCode=${partnerCode}`;
            const response: AxiosResponse<ApiResponse<{ items: any[]; totalCount: number }>> = 
                await this.httpService.getRequest<{ items: any[]; totalCount: number }>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: null
                };
            } else {
                throw new Error(response.data.message || 'Failed to fetch transport mode data');
            }
        } catch (error) {
            throw error;
        }
    }

    async CreateTransportModeData(request: TransportModeCreateRequestList): Promise<TransportModeCreateResponse> {
        try {
            const endpoint = 'coredata/transportmode/create';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.postRequest<boolean, TransportModeCreateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to create transport mode data');
            }
        } catch (error) {
            throw error;
        }
    }

    async GetOTMContactData(pageNumber: number, pageSize: number, partnerCode: string): Promise<OTMContactDataResponse> {
        try {
            const endpoint = `coredata/contact/getall?pageNumber=${pageNumber}&pageSize=${pageSize}&partnerCode=${partnerCode}`;
            const response: AxiosResponse<ApiResponse<OTMContactData>> = 
                await this.httpService.getRequest<OTMContactData>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to fetch OTM contact data');
            }
        } catch (error) {
            throw error;
        }
    }

    async CreateOTMContactData(request: OTMContactCreateRequestList): Promise<OTMContactCreateResponse> {
        try {
            const endpoint = 'coredata/contact/create';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.postRequest<boolean, OTMContactCreateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to create OTM contact data');
            }
        } catch (error) {
            throw error;
        }
    }

    async UpdateOTMContactData(request: OTMContactUpdateRequestList): Promise<OTMContactUpdateResponse> {
        try {
            const endpoint = 'coredata/contact/update-list';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.putRequest<boolean, OTMContactUpdateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to update OTM Contact data');
            }
        } catch (error) {
            throw error;
        }
    }

    async DeleteOTMContactData(id: string): Promise<OTMContactDeleteResponse> {
        try {
            const endpoint = `coredata/contact/${id}`;
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.deleteRequest<boolean, void>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to delete OTM Contact data');
            }
        } catch (error) {
            throw error;
        }
    }

    async GetOTMContactComMethodData(pageNumber: number, pageSize: number, partnerCode: string): Promise<OTMContactComMethodDataResponse> {
        try {
            const endpoint = `coredata/contactcommethod/getall?pageNumber=${pageNumber}&pageSize=${pageSize}&partnerCode=${partnerCode}`;
            const response: AxiosResponse<ApiResponse<OTMContactComMethodData>> = 
                await this.httpService.getRequest<OTMContactComMethodData>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to fetch OTM contact com method data');
            }
        } catch (error) {
            throw error;
        }
    }

    async CreateOTMContactComMethodData(request: OTMContactComMethodCreateRequestList): Promise<OTMContactComMethodCreateResponse> {
        try {
            const endpoint = 'coredata/contactcommethod/create';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.postRequest<boolean, OTMContactComMethodCreateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to create OTM contact com method data');
            }
        } catch (error) {
            throw error;
        }
    }

    async UpdateOTMContactComMethodData(request: OTMContactComMethodUpdateRequestList): Promise<OTMContactComMethodUpdateResponse> {
        try {
            const endpoint = 'coredata/contactcommethod/update-list';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.putRequest<boolean, OTMContactComMethodUpdateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to update OTM Contact Com Method data');
            }
        } catch (error) {
            throw error;
        }
    }

    async DeleteOTMContactComMethodData(id: string): Promise<OTMContactComMethodDeleteResponse> {
        try {
            const endpoint = `coredata/contactcommethod/${id}`;
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.deleteRequest<boolean, void>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to delete OTM Contact Com Method data');
            }
        } catch (error) {
            throw error;
        }
    }

    async GetOTMXLaneData(pageNumber: number, pageSize: number, partnerCode: string): Promise<OTMXLaneDataResponse> {
        try {
            const endpoint = `coredata/xlane/getall?pageNumber=${pageNumber}&pageSize=${pageSize}&partnerCode=${partnerCode}`;
            const response: AxiosResponse<ApiResponse<OTMXLaneData>> = 
                await this.httpService.getRequest<OTMXLaneData>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to fetch OTM XLane data');
            }
        } catch (error) {
            throw error;
        }
    }

    async CreateOTMXLaneData(request: OTMXLaneCreateRequestList): Promise<OTMXLaneCreateResponse> {
        try {
            const endpoint = 'coredata/xlane/create';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.postRequest<boolean, OTMXLaneCreateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to create OTM XLane data');
            }
        } catch (error) {
            throw error;
        }
    }

    async UpdateOTMXLaneData(request: OTMXLaneUpdateRequestList): Promise<OTMXLaneUpdateResponse> {
        try {
            const endpoint = 'coredata/xlane/update-list';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.putRequest<boolean, OTMXLaneUpdateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to update OTM XLane data');
            }
        } catch (error) {
            throw error;
        }
    }

    async DeleteOTMXLaneData(id: string): Promise<OTMXLaneDeleteResponse> {
        try {
            const endpoint = `coredata/xlane/${id}`;
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.deleteRequest<boolean, void>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to delete OTM XLane data');
            }
        } catch (error) {
            throw error;
        }
    }

    async GetOTMServiceProviderData(pageNumber: number, pageSize: number, partnerCode: string): Promise<OTMServiceProviderDataResponse> {
        try {
            const endpoint = `coredata/servprovider/getall?pageNumber=${pageNumber}&pageSize=${pageSize}&partnercode=${partnerCode}`;
            const response: AxiosResponse<ApiResponse<OTMServiceProviderData>> = 
                await this.httpService.getRequest<OTMServiceProviderData>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to fetch OTM Service Provider data');
            }
        } catch (error) {
            throw error;
        }
    }

    async CreateOTMServiceProviderData(request: OTMServiceProviderCreateRequestList): Promise<OTMServiceProviderCreateResponse> {
        try {
            const endpoint = 'coredata/servprovider/create';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.postRequest<boolean, OTMServiceProviderCreateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to create OTM Service Provider data');
            }
        } catch (error) {
            throw error;
        }
    }

    async UpdateOTMServiceProviderData(request: OTMServiceProviderUpdateRequestList): Promise<OTMServiceProviderUpdateResponse> {
        try {
            const endpoint = 'coredata/servprovider/update-list';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.putRequest<boolean, OTMServiceProviderUpdateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to update OTM Service Provider data');
            }
        } catch (error) {
            throw error;
        }
    }

    async DeleteOTMServiceProviderData(id: string): Promise<OTMServiceProviderDeleteResponse> {
        try {
            const endpoint = `coredata/servprovider/${id}`;
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.deleteRequest<boolean, void>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to delete OTM Service Provider data');
            }
        } catch (error) {
            throw error;
        }
    }

    async GetOTMServProvProfileData(pageNumber: number, pageSize: number, partnerCode: string): Promise<OTMServProvProfileDataResponse> {
        try {
            const endpoint = `coredata/servprovprofile/getall?pageNumber=${pageNumber}&pageSize=${pageSize}&partnercode=${partnerCode}`;
            const response: AxiosResponse<ApiResponse<OTMServProvProfileData>> = 
                await this.httpService.getRequest<OTMServProvProfileData>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to fetch OTM ServProvProfile data');
            }
        } catch (error) {
            throw error;
        }
    }

    async CreateOTMServProvProfileData(request: OTMServProvProfileCreateRequestList): Promise<OTMServProvProfileCreateResponse> {
        try {
            const endpoint = 'coredata/servprovprofile/create';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.postRequest<boolean, OTMServProvProfileCreateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to create OTM ServProvProfile data');
            }
        } catch (error) {
            throw error;
        }
    }

    async UpdateOTMServProvProfileData(request: OTMServProvProfileUpdateRequestList): Promise<OTMServProvProfileUpdateResponse> {
        try {
            const endpoint = 'coredata/servprovprofile/update-list';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.putRequest<boolean, OTMServProvProfileUpdateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to update OTM ServProvProfile data');
            }
        } catch (error) {
            throw error;
        }
    }

    async DeleteOTMServProvProfileData(id: string): Promise<OTMServProvProfileDeleteResponse> {
        try {
            const endpoint = `coredata/servprovprofile/${id}`;
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.deleteRequest<boolean, void>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to delete OTM Service Provider Profile data');
            }
        } catch (error) {
            throw error;
        }
    }

    async GetOTMItemData(pageNumber: number, pageSize: number, partnerCode: string): Promise<OTMItemDataResponse> {
        try {
            const endpoint = `coredata/item/getall?pageNumber=${pageNumber}&pageSize=${pageSize}&partnerCode=${partnerCode}`;
            const response: AxiosResponse<ApiResponse<OTMItemData>> = 
                await this.httpService.getRequest<OTMItemData>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to retrieve OTM Item data');
            }
        } catch (error) {
            throw error;
        }
    }

    async CreateOTMItemData(request: OTMItemCreateRequestList): Promise<OTMItemCreateResponse> {
        try {
            const endpoint = 'coredata/item/create';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.postRequest<boolean, OTMItemCreateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to create OTM Item data');
            }
        } catch (error) {
            throw error;
        }
    }

    async UpdateOTMItemData(request: OTMItemUpdateRequestList): Promise<OTMItemUpdateResponse> {
        try {
            const endpoint = 'coredata/item/update-list';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.putRequest<boolean, OTMItemUpdateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to update OTM Item data');
            }
        } catch (error) {
            throw error;
        }
    }

    async DeleteOTMItemData(id: string): Promise<OTMItemDeleteResponse> {
        try {
            const endpoint = `coredata/item/${id}`;
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.deleteRequest<boolean, void>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to delete OTM Item data');
            }
        } catch (error) {
            throw error;
        }
    }

    async GetOTMPackagedItemData(pageNumber: number, pageSize: number, partnerCode: string): Promise<OTMPackagedItemDataResponse> {
        try {
            const endpoint = `coredata/packageditem/getall?pageNumber=${pageNumber}&pageSize=${pageSize}&partnerCode=${partnerCode}`;
            const response: AxiosResponse<ApiResponse<OTMPackagedItemData>> = 
                await this.httpService.getRequest<OTMPackagedItemData>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to retrieve OTM Packaged Item data');
            }
        } catch (error) {
            throw error;
        }
    }

    async CreateOTMPackagedItemData(request: OTMPackagedItemCreateRequestList): Promise<OTMPackagedItemCreateResponse> {
        try {
            const endpoint = 'coredata/packageditem/create';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.postRequest<boolean, OTMPackagedItemCreateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to create OTM Packaged Item data');
            }
        } catch (error) {
            throw error;
        }
    }

    async UpdateOTMPackagedItemData(request: OTMPackagedItemUpdateRequestList): Promise<OTMPackagedItemUpdateResponse> {
        try {
            const endpoint = 'coredata/packageditem/update-list';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.putRequest<boolean, OTMPackagedItemUpdateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to update OTM Packaged Item data');
            }
        } catch (error) {
            throw error;
        }
    }

    async DeleteOTMPackagedItemData(id: string): Promise<OTMPackagedItemDeleteResponse> {
        try {
            const endpoint = `coredata/packageditem/${id}`;
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.deleteRequest<boolean, void>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to delete OTM Packaged Item data');
            }
        } catch (error) {
            throw error;
        }
    }

    /**
     * Get all Equipment Group Profile data with pagination
     */
    async GetOTMEquipmentGroupProfileData(pageNumber: number, pageSize: number, partnerCode: string): Promise<OTMEquipmentGroupProfileDataResponse> {
        try {
            const endpoint = `coredata/equipmentgroupprofile/getall?pageNumber=${pageNumber}&pageSize=${pageSize}&partnerCode=${partnerCode}`;
            const response: AxiosResponse<ApiResponse<OTMEquipmentGroupProfileData>> = 
                await this.httpService.getRequest<OTMEquipmentGroupProfileData>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to fetch OTM Equipment Group Profile data');
            }
        } catch (error) {
            throw error;
        }
    }

    /**
     * Create new Equipment Group Profile data
     */
    async CreateOTMEquipmentGroupProfileData(request: OTMEquipmentGroupProfileCreateRequestList): Promise<OTMEquipmentGroupProfileCreateResponse> {
        try {
            const endpoint = 'coredata/equipmentgroupprofile/create';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.postRequest<boolean, OTMEquipmentGroupProfileCreateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to create OTM Equipment Group Profile data');
            }
        } catch (error) {
            throw error;
        }
    }

    async UpdateOTMEquipmentGroupProfileData(request: OTMEquipmentGroupProfileUpdateRequestList): Promise<OTMEquipmentGroupProfileUpdateResponse> {
        try {
            const endpoint = 'coredata/equipmentgroupprofile/update-list';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.putRequest<boolean, OTMEquipmentGroupProfileUpdateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to update OTM Equipment Group Profile data');
            }
        } catch (error) {
            throw error;
        }
    }

    async DeleteOTMEquipmentGroupProfileData(gid: string): Promise<OTMEquipmentGroupProfileDeleteResponse> {
        try {
            const endpoint = `coredata/equipmentgroupprofile/${gid}`;
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.deleteRequest<boolean, void>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to delete OTM Equipment Group Profile data');
            }
        } catch (error) {
            throw error;
        }
    }

    /**
     * Get all Equipment Group Profile D data with pagination
     */
    async GetOTMEquipmentGroupProfileDData(pageNumber: number, pageSize: number, partnerCode: string): Promise<OTMEquipmentGroupProfileDDataResponse> {
        try {
            const endpoint = `coredata/equipmentgroupprofiled/getall?pageNumber=${pageNumber}&pageSize=${pageSize}&partnerCode=${partnerCode}`;
            const response: AxiosResponse<ApiResponse<OTMEquipmentGroupProfileDData>> = 
                await this.httpService.getRequest<OTMEquipmentGroupProfileDData>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to fetch OTM Equipment Group Profile D data');
            }
        } catch (error) {
            throw error;
        }
    }

    /**
     * Create new Equipment Group Profile D data
     */
    async CreateOTMEquipmentGroupProfileDData(request: OTMEquipmentGroupProfileDCreateRequestList): Promise<OTMEquipmentGroupProfileDCreateResponse> {
        try {
            const endpoint = 'coredata/equipmentgroupprofiled/create';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.postRequest<boolean, OTMEquipmentGroupProfileDCreateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to create OTM Equipment Group Profile D data');
            }
        } catch (error) {
            throw error;
        }
    }

    async UpdateOTMEquipmentGroupProfileDData(request: OTMEquipmentGroupProfileDUpdateRequestList): Promise<OTMEquipmentGroupProfileDUpdateResponse> {
        try {
            const endpoint = 'coredata/equipmentgroupprofiled/update-list';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.putRequest<boolean, OTMEquipmentGroupProfileDUpdateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to update OTM Equipment Group Profile D data');
            }
        } catch (error) {
            throw error;
        }
    }

    async DeleteOTMEquipmentGroupProfileDData(id: string): Promise<OTMEquipmentGroupProfileDDeleteResponse> {
        try {
            const endpoint = `coredata/equipmentgroupprofiled/${id}`;
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.deleteRequest<boolean, void>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to delete OTM Equipment Group Profile D data');
            }
        } catch (error) {
            throw error;
        }
    }

    /**
     * Get Mode Profile data
     */
    async GetOTMModeProfileData(pageNumber: number, pageSize: number, partnerCode: string): Promise<OTMModeProfileDataResponse> {
        try {
            const endpoint = `coredata/modeprofile/getall?pageNumber=${pageNumber}&pageSize=${pageSize}&partnerCode=${partnerCode}`;
            const response: AxiosResponse<ApiResponse<OTMModeProfileData>> = 
                await this.httpService.getRequest<OTMModeProfileData>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to fetch OTM Mode Profile data');
            }
        } catch (error) {
            throw error;
        }
    }

    /**
     * Create new Mode Profile data
     */
    async CreateOTMModeProfileData(request: OTMModeProfileCreateRequestList): Promise<OTMModeProfileCreateResponse> {
        try {
            const endpoint = 'coredata/modeprofile/create';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.postRequest<boolean, OTMModeProfileCreateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to create OTM Mode Profile data');
            }
        } catch (error) {
            throw error;
        }
    }

    async UpdateOTMModeProfileData(request: OTMModeProfileUpdateRequestList): Promise<OTMModeProfileUpdateResponse> {
        try {
            const endpoint = 'coredata/modeprofile/update-list';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.putRequest<boolean, OTMModeProfileUpdateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to update OTM Mode Profile data');
            }
        } catch (error) {
            throw error;
        }
    }

    async DeleteOTMModeProfileData(id: string): Promise<OTMModeProfileDeleteResponse> {
        try {
            const endpoint = `coredata/modeprofile/${id}`;
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.deleteRequest<boolean, void>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to delete OTM Mode Profile data');
            }
        } catch (error) {
            throw error;
        }
    }

    /**
     * Get Mode Profile Detail data
     */
    async GetOTMModeProfileDetailData(pageNumber: number, pageSize: number, partnerCode: string): Promise<OTMModeProfileDetailDataResponse> {
        try {
            const endpoint = `coredata/modeprofiledetail/getall?pageNumber=${pageNumber}&pageSize=${pageSize}&partnerCode=${partnerCode}`;
            const response: AxiosResponse<ApiResponse<OTMModeProfileDetailData>> = 
                await this.httpService.getRequest<OTMModeProfileDetailData>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to fetch OTM Mode Profile Detail data');
            }
        } catch (error) {
            throw error;
        }
    }

    /**
     * Create new Mode Profile Detail data
     */
    async CreateOTMModeProfileDetailData(request: OTMModeProfileDetailCreateRequestList): Promise<OTMModeProfileDetailCreateResponse> {
        try {
            const endpoint = 'coredata/modeprofiledetail/create';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.postRequest<boolean, OTMModeProfileDetailCreateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to create OTM Mode Profile Detail data');
            }
        } catch (error) {
            throw error;
        }
    }

    async UpdateOTMModeProfileDetailData(request: OTMModeProfileDetailUpdateRequestList): Promise<OTMModeProfileDetailUpdateResponse> {
        try {
            const endpoint = 'coredata/modeprofiledetail/update-list';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.putRequest<boolean, OTMModeProfileDetailUpdateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to update OTM Mode Profile Detail data');
            }
        } catch (error) {
            throw error;
        }
    }

    async DeleteOTMModeProfileDetailData(id: string): Promise<OTMModeProfileDetailDeleteResponse> {
        try {
            const endpoint = `coredata/modeprofiledetail/${id}`;
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.deleteRequest<boolean, void>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to delete OTM Mode Profile Detail data');
            }
        } catch (error) {
            throw error;
        }
    }

    async GetGlKeyComponentData(pageNumber: number, pageSize: number, partnerCode: string): Promise<GlKeyComponentDataResponse> {
        try {
            const endpoint = `coredata/glkeycomponent/getall?pageNumber=${pageNumber}&pageSize=${pageSize}&partnerCode=${partnerCode}`;
            const response: AxiosResponse<ApiResponse<GlKeyComponentData>> = 
                await this.httpService.getRequest<GlKeyComponentData>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to fetch GL Key Component data');
            }
        } catch (error) {
            throw error;
        }
    }

    async CreateGlKeyComponentData(request: GlKeyComponentCreateRequestList): Promise<GlKeyComponentCreateResponse> {
        try {
            const endpoint = 'coredata/glkeycomponent/create';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.postRequest<boolean, GlKeyComponentCreateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to create GL Key Component data');
            }
        } catch (error) {
            throw error;
        }
    }

    async UpdateGlKeyComponentData(request: GlKeyComponentUpdateRequestList): Promise<GlKeyComponentUpdateResponse> {
        try {
            const endpoint = 'coredata/glkeycomponent/update-list';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.putRequest<boolean, GlKeyComponentUpdateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message || 'Success'
                };
            } else {
                throw new Error(response.data.message || 'Failed to update GL Key Component data');
            }
        } catch (error) {
            throw error;
        }
    }

    async DeleteGlKeyComponentData(id: string): Promise<GlKeyComponentDeleteResponse> {
        try {
            const endpoint = `coredata/glkeycomponent/${id}`;
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.deleteRequest<boolean, void>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to delete GL Key Component data');
            }
        } catch (error) {
            throw error;
        }
    }

    async GetGlKeyComponentParamData(pageNumber: number, pageSize: number, partnerCode: string): Promise<GlKeyComponentParamDataResponse> {
        try {
            const endpoint = `coredata/glkeycomponentparam/getall?pageNumber=${pageNumber}&pageSize=${pageSize}&partnerCode=${partnerCode}`;
            const response: AxiosResponse<ApiResponse<GlKeyComponentParamData>> = 
                await this.httpService.getRequest<GlKeyComponentParamData>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to fetch GL Key Component Param data');
            }
        } catch (error) {
            throw error;
        }
    }

    async CreateGlKeyComponentParamData(request: GlKeyComponentParamCreateRequestList): Promise<GlKeyComponentParamCreateResponse> {
        try {
            const endpoint = 'coredata/glkeycomponentparam/create';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.postRequest<boolean, GlKeyComponentParamCreateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to create GL Key Component Param data');
            }
        } catch (error) {
            throw error;
        }
    }

    async UpdateGlKeyComponentParamData(request: GlKeyComponentParamUpdateRequestList): Promise<GlKeyComponentParamUpdateResponse> {
        try {
            const endpoint = 'coredata/glkeycomponentparam/update-list';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.putRequest<boolean, GlKeyComponentParamUpdateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to update GL Key Component Param data');
            }
        } catch (error) {
            throw error;
        }
    }

    async DeleteGlKeyComponentParamData(id: string): Promise<GlKeyComponentParamDeleteResponse> {
        try {
            const endpoint = `coredata/glkeycomponentparam/${id}`;
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.deleteRequest<boolean, void>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to delete GL Key Component Param data');
            }
        } catch (error) {
            throw error;
        }
    }

    // GL Lookup Key methods
    async GetGlLookupKeyData(pageNumber: number, pageSize: number, partnerCode: string): Promise<GlLookupKeyDataResponse> {
        try {
            const response: AxiosResponse<ApiResponse<GlLookupKeyData>> = await this.httpService.getRequest<GlLookupKeyData>(
                `coredata/gllookupkey/getall?pageNumber=${pageNumber}&pageSize=${pageSize}&partnerCode=${encodeURIComponent(partnerCode)}`
            );
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to fetch GL Lookup Key data');
            }
        } catch (error) {
            throw error;
        }
    }

    async CreateGlLookupKeyData(request: GlLookupKeyCreateRequestList): Promise<GlLookupKeyCreateResponse> {
        try {
            const endpoint = 'coredata/gllookupkey/create';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.postRequest<boolean, GlLookupKeyCreateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to create GL Lookup Key data');
            }
        } catch (error) {
            throw error;
        }
    }

    async UpdateGlLookupKeyData(request: GlLookupKeyUpdateRequestList): Promise<GlLookupKeyUpdateResponse> {
        try {
            const endpoint = 'coredata/gllookupkey/update-list';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.putRequest<boolean, GlLookupKeyUpdateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message || 'Success'
                };
            } else {
                throw new Error(response.data.message || 'Failed to update GL Lookup Key data');
            }
        } catch (error) {
            throw error;
        }
    }

    async DeleteGlLookupKeyData(id: string): Promise<GlLookupKeyDeleteResponse> {
        try {
            const endpoint = `coredata/gllookupkey/${id}`;
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.deleteRequest<boolean, void>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to delete GL Lookup Key data');
            }
        } catch (error) {
            throw error;
        }
    }

    // GL Lookup Key D (child) methods
    async GetGlLookupKeyDData(pageNumber: number, pageSize: number, partnerCode: string): Promise<GlLookupKeyDDataResponse> {
        try {
            const response: AxiosResponse<ApiResponse<GlLookupKeyDData>> = await this.httpService.getRequest<GlLookupKeyDData>(
                `coredata/gllookupkeyd/getall?pageNumber=${pageNumber}&pageSize=${pageSize}&partnerCode=${encodeURIComponent(partnerCode)}`
            );
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to fetch GL Lookup Key D data');
            }
        } catch (error) {
            throw error;
        }
    }

    async CreateGlLookupKeyDData(request: GlLookupKeyDCreateRequestList): Promise<GlLookupKeyDCreateResponse> {
        try {
            const endpoint = 'coredata/gllookupkeyd/create';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.postRequest<boolean, GlLookupKeyDCreateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to create GL Lookup Key D data');
            }
        } catch (error) {
            throw error;
        }
    }

    async UpdateGlLookupKeyDData(request: GlLookupKeyDUpdateRequestList): Promise<GlLookupKeyDUpdateResponse> {
        try {
            const endpoint = 'coredata/gllookupkeyd/update-list';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.putRequest<boolean, GlLookupKeyDUpdateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message || 'Success'
                };
            } else {
                throw new Error(response.data.message || 'Failed to update GL Lookup Key D data');
            }
        } catch (error) {
            throw error;
        }
    }

    async DeleteGlLookupKeyDData(id: string): Promise<GlLookupKeyDDeleteResponse> {
        try {
            const endpoint = `coredata/gllookupkeyd/${id}`;
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.deleteRequest<boolean, void>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to delete GL Lookup Key D data');
            }
        } catch (error) {
            throw error;
        }
    }

    async GetGeneralLedgerCodeData(pageNumber: number, pageSize: number, partnerCode: string): Promise<GeneralLedgerCodeDataResponse> {
        try {
            const endpoint = `coredata/generalledgercode/getall?pageNumber=${pageNumber}&pageSize=${pageSize}&partnerCode=${partnerCode}`;
            const response: AxiosResponse<ApiResponse<GeneralLedgerCodeData>> = 
                await this.httpService.getRequest<GeneralLedgerCodeData>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to fetch General Ledger Code data');
            }
        } catch (error) {
            throw error;
        }
    }

    async CreateGeneralLedgerCodeData(request: GeneralLedgerCodeCreateRequestList): Promise<GeneralLedgerCodeCreateResponse> {
        try {
            const endpoint = 'coredata/generalledgercode/create';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.postRequest<boolean, GeneralLedgerCodeCreateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to create General Ledger Code data');
            }
        } catch (error) {
            throw error;
        }
    }

    async UpdateGeneralLedgerCodeData(request: GeneralLedgerCodeUpdateRequestList): Promise<GeneralLedgerCodeUpdateResponse> {
        try {
            const endpoint = 'coredata/generalledgercode/update-list';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.putRequest<boolean, GeneralLedgerCodeUpdateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message || 'Success'
                };
            } else {
                throw new Error(response.data.message || 'Failed to update General Ledger Code data');
            }
        } catch (error) {
            throw error;
        }
    }

    async DeleteGeneralLedgerCodeData(id: string): Promise<GeneralLedgerCodeDeleteResponse> {
        try {
            const endpoint = `coredata/generalledgercode/${id}`;
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.deleteRequest<boolean, void>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to delete General Ledger Code data');
            }
        } catch (error) {
            throw error;
        }
    }

    async GetGLCodeMapData(pageNumber: number, pageSize: number, partnerCode: string): Promise<GLCodeMapDataResponse> {
        try {
            const endpoint = `coredata/glcodemap/getall?pageNumber=${pageNumber}&pageSize=${pageSize}&partnerCode=${partnerCode}`;
            const response: AxiosResponse<ApiResponse<GLCodeMapData>> = 
                await this.httpService.getRequest<GLCodeMapData>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to fetch GL Code Map data');
            }
        } catch (error) {
            throw error;
        }
    }

    async CreateGLCodeMapData(request: GLCodeMapCreateRequestList): Promise<GLCodeMapCreateResponse> {
        try {
            const endpoint = 'coredata/glcodemap/create';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.postRequest<boolean, GLCodeMapCreateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to create GL Code Map data');
            }
        } catch (error) {
            throw error;
        }
    }

    async UpdateGLCodeMapData(request: GLCodeMapUpdateRequestList): Promise<GLCodeMapUpdateResponse> {
        try {
            const endpoint = 'coredata/glcodemap/update-list';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.putRequest<boolean, GLCodeMapUpdateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message || 'Success'
                };
            } else {
                throw new Error(response.data.message || 'Failed to update GL Code Map data');
            }
        } catch (error) {
            throw error;
        }
    }

    async DeleteGLCodeMapData(id: string): Promise<GLCodeMapDeleteResponse> {
        try {
            const endpoint = `coredata/glcodemap/${id}`;
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.deleteRequest<boolean, void>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to delete GL Code Map data');
            }
        } catch (error) {
            throw error;
        }
    }

    async GetMessageCodeMapData(pageNumber: number, pageSize: number, partnerCode: string): Promise<MessageCodeMapDataResponse> {
        try {
            const endpoint = `coredata/messagecodemap/getall?pageNumber=${pageNumber}&pageSize=${pageSize}&partnerCode=${partnerCode}`;
            const response: AxiosResponse<ApiResponse<MessageCodeMapData>> = 
                await this.httpService.getRequest<MessageCodeMapData>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to fetch Message Code Map data');
            }
        } catch (error) {
            throw error;
        }
    }

    async CreateMessageCodeMapData(request: MessageCodeMapCreateRequestList): Promise<MessageCodeMapCreateResponse> {
        try {
            const endpoint = 'coredata/messagecodemap/create';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.postRequest<boolean, MessageCodeMapCreateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to create Message Code Map data');
            }
        } catch (error) {
            throw error;
        }
    }

    async UpdateMessageCodeMapData(request: MessageCodeMapUpdateRequestList): Promise<MessageCodeMapUpdateResponse> {
        try {
            const endpoint = 'coredata/messagecodemap/update-list';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.putRequest<boolean, MessageCodeMapUpdateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message || 'Success'
                };
            } else {
                throw new Error(response.data.message || 'Failed to update Message Code Map data');
            }
        } catch (error) {
            throw error;
        }
    }

    async DeleteMessageCodeMapData(id: string): Promise<MessageCodeMapDeleteResponse> {
        try {
            const endpoint = `coredata/messagecodemap/${id}`;
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.deleteRequest<boolean, void>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to delete Message Code Map data');
            }
        } catch (error) {
            throw error;
        }
    }

    async GetMessageCodeMapDData(pageNumber: number, pageSize: number, partnerCode: string): Promise<MessageCodeMapDDataResponse> {
        try {
            const endpoint = `coredata/messagecodemapd/getall?pageNumber=${pageNumber}&pageSize=${pageSize}&partnerCode=${partnerCode}`;
            const response: AxiosResponse<ApiResponse<MessageCodeMapDData>> = 
                await this.httpService.getRequest<MessageCodeMapDData>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to fetch Message Code Map D data');
            }
        } catch (error) {
            throw error;
        }
    }

    async CreateMessageCodeMapDData(request: MessageCodeMapDCreateRequestList): Promise<MessageCodeMapDCreateResponse> {
        try {
            const endpoint = 'coredata/messagecodemapd/create';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.postRequest<boolean, MessageCodeMapDCreateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to create Message Code Map D data');
            }
        } catch (error) {
            throw error;
        }
    }

    async UpdateMessageCodeMapDData(request: MessageCodeMapDUpdateRequestList): Promise<MessageCodeMapDUpdateResponse> {
        try {
            const endpoint = 'coredata/messagecodemapd/update-list';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.putRequest<boolean, MessageCodeMapDUpdateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message || 'Success'
                };
            } else {
                throw new Error(response.data.message || 'Failed to update Message Code Map D data');
            }
        } catch (error) {
            throw error;
        }
    }

    async DeleteMessageCodeMapDData(id: string): Promise<MessageCodeMapDDeleteResponse> {
        try {
            const endpoint = `coredata/messagecodemapd/${id}`;
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.deleteRequest<boolean, void>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to delete Message Code Map D data');
            }
        } catch (error) {
            throw error;
        }
    }

    async GetSpecialServiceProfileData(pageNumber: number, pageSize: number, partnerCode: string): Promise<SpecialServiceProfileDataResponse> {
        try {
            const endpoint = `coredata/specialserviceprofile/getall?pageNumber=${pageNumber}&pageSize=${pageSize}&partnerCode=${partnerCode}`;
            const response: AxiosResponse<ApiResponse<SpecialServiceProfileData>> = 
                await this.httpService.getRequest<SpecialServiceProfileData>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message || 'Success'
                };
            } else {
                throw new Error(response.data.message || 'Failed to fetch Special Service Profile data');
            }
        } catch (error) {
            throw error;
        }
    }

    async CreateSpecialServiceProfileData(request: SpecialServiceProfileCreateRequestList): Promise<SpecialServiceProfileCreateResponse> {
        try {
            const endpoint = 'coredata/specialserviceprofile/create';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.postRequest<boolean, SpecialServiceProfileCreateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message || 'Success'
                };
            } else {
                throw new Error(response.data.message || 'Failed to create Special Service Profile data');
            }
        } catch (error) {
            throw error;
        }
    }

    async UpdateSpecialServiceProfileData(request: SpecialServiceProfileUpdateRequestList): Promise<SpecialServiceProfileUpdateResponse> {
        try {
            const endpoint = 'coredata/specialserviceprofile/update-list';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.putRequest<boolean, SpecialServiceProfileUpdateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message || 'Success'
                };
            } else {
                throw new Error(response.data.message || 'Failed to update Special Service Profile data');
            }
        } catch (error) {
            throw error;
        }
    }

    async DeleteSpecialServiceProfileData(id: string): Promise<SpecialServiceProfileDeleteResponse> {
        try {
            const endpoint = `coredata/specialserviceprofile/${id}`;
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.deleteRequest<boolean, void>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to delete Special Service Profile data');
            }
        } catch (error) {
            throw error;
        }
    }

    async GetSpecialServiceProfileDData(pageNumber: number, pageSize: number, partnerCode: string): Promise<SpecialServiceProfileDDataResponse> {
        try {
            const endpoint = `coredata/specialserviceprofiled/getall?pageNumber=${pageNumber}&pageSize=${pageSize}&partnerCode=${partnerCode}`;
            const response: AxiosResponse<ApiResponse<SpecialServiceProfileDData>> = 
                await this.httpService.getRequest<SpecialServiceProfileDData>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message || 'Success'
                };
            } else {
                throw new Error(response.data.message || 'Failed to fetch Special Service Profile D data');
            }
        } catch (error) {
            throw error;
        }
    }

    async CreateSpecialServiceProfileDData(request: SpecialServiceProfileDCreateRequestList): Promise<SpecialServiceProfileDCreateResponse> {
        try {
            const endpoint = 'coredata/specialserviceprofiled/create';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.postRequest<boolean, SpecialServiceProfileDCreateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message || 'Success'
                };
            } else {
                throw new Error(response.data.message || 'Failed to create Special Service Profile D data');
            }
        } catch (error) {
            throw error;
        }
    }

    async UpdateSpecialServiceProfileDData(request: SpecialServiceProfileDUpdateRequestList): Promise<SpecialServiceProfileDUpdateResponse> {
        try {
            const endpoint = 'coredata/specialserviceprofiled/update-list';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.putRequest<boolean, SpecialServiceProfileDUpdateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message || 'Success'
                };
            } else {
                throw new Error(response.data.message || 'Failed to update Special Service Profile D data');
            }
        } catch (error) {
            throw error;
        }
    }

    async DeleteSpecialServiceProfileDData(id: string): Promise<SpecialServiceProfileDDeleteResponse> {
        try {
            const endpoint = `coredata/specialserviceprofiled/${id}`;
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.deleteRequest<boolean, void>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to delete Special Service Profile D data');
            }
        } catch (error) {
            throw error;
        }
    }

    async GetShipUnitSpecProfileData(pageNumber: number, pageSize: number, partnerCode: string): Promise<ShipUnitSpecProfileDataResponse> {
        try {
            const endpoint = `coredata/shipunitspecprofile/getall?pageNumber=${pageNumber}&pageSize=${pageSize}&partnerCode=${partnerCode}`;
            const response: AxiosResponse<ApiResponse<ShipUnitSpecProfileData>> = 
                await this.httpService.getRequest<ShipUnitSpecProfileData>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message || 'Success'
                };
            } else {
                throw new Error(response.data.message || 'Failed to get Ship Unit Spec Profile data');
            }
        } catch (error) {
            throw error;
        }
    }

    async CreateShipUnitSpecProfileData(request: ShipUnitSpecProfileCreateRequestList): Promise<ShipUnitSpecProfileCreateResponse> {
        try {
            const endpoint = 'coredata/shipunitspecprofile/create';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.postRequest<boolean, ShipUnitSpecProfileCreateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message || 'Success'
                };
            } else {
                throw new Error(response.data.message || 'Failed to create Ship Unit Spec Profile data');
            }
        } catch (error) {
            throw error;
        }
    }

    async UpdateShipUnitSpecProfileData(request: ShipUnitSpecProfileUpdateRequestList): Promise<ShipUnitSpecProfileUpdateResponse> {
        try {
            const endpoint = 'coredata/shipunitspecprofile/update-list';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.putRequest<boolean, ShipUnitSpecProfileUpdateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message || 'Success'
                };
            } else {
                throw new Error(response.data.message || 'Failed to update Ship Unit Spec Profile data');
            }
        } catch (error) {
            throw error;
        }
    }

    async DeleteShipUnitSpecProfileData(id: string): Promise<ShipUnitSpecProfileDeleteResponse> {
        try {
            const endpoint = `coredata/shipunitspecprofile/${id}`;
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.deleteRequest<boolean, void>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to delete Ship Unit Spec Profile data');
            }
        } catch (error) {
            throw error;
        }
    }

    async GetShipUnitSpecProfileDData(pageNumber: number, pageSize: number, partnerCode: string): Promise<ShipUnitSpecProfileDDataResponse> {
        try {
            const endpoint = `coredata/shipunitspecprofiled/getall?pageNumber=${pageNumber}&pageSize=${pageSize}&partnerCode=${partnerCode}`;
            const response: AxiosResponse<ApiResponse<ShipUnitSpecProfileDData>> = 
                await this.httpService.getRequest<ShipUnitSpecProfileDData>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message || 'Success'
                };
            } else {
                throw new Error(response.data.message || 'Failed to get Ship Unit Spec Profile D data');
            }
        } catch (error) {
            throw error;
        }
    }

    async CreateShipUnitSpecProfileDData(request: ShipUnitSpecProfileDCreateRequestList): Promise<ShipUnitSpecProfileDCreateResponse> {
        try {
            const endpoint = 'coredata/shipunitspecprofiled/create';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.postRequest<boolean, ShipUnitSpecProfileDCreateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message || 'Success'
                };
            } else {
                throw new Error(response.data.message || 'Failed to create Ship Unit Spec Profile D data');
            }
        } catch (error) {
            throw error;
        }
    }

    async UpdateShipUnitSpecProfileDData(request: ShipUnitSpecProfileDUpdateRequestList): Promise<ShipUnitSpecProfileDUpdateResponse> {
        try {
            const endpoint = 'coredata/shipunitspecprofiled/update-list';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.putRequest<boolean, ShipUnitSpecProfileDUpdateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message || 'Success'
                };
            } else {
                throw new Error(response.data.message || 'Failed to update Ship Unit Spec Profile D data');
            }
        } catch (error) {
            throw error;
        }
    }

    async DeleteShipUnitSpecProfileDData(id: string): Promise<ShipUnitSpecProfileDDeleteResponse> {
        try {
            const endpoint = `coredata/shipunitspecprofiled/${id}`;
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.deleteRequest<boolean, void>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to delete Ship Unit Spec Profile D data');
            }
        } catch (error) {
            throw error;
        }
    }

    async GetWorkflowParamData(pageNumber: number, pageSize: number, partnerCode: string): Promise<WorkflowParamDataResponse> {
        try {
            const endpoint = `coredata/workflowparam/getall?pageNumber=${pageNumber}&pageSize=${pageSize}&partnerCode=${partnerCode}`;
            const response: AxiosResponse<ApiResponse<WorkflowParamData>> = 
                await this.httpService.getRequest<WorkflowParamData>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message || 'Success'
                };
            } else {
                throw new Error(response.data.message || 'Failed to get Workflow Parameter data');
            }
        } catch (error) {
            throw error;
        }
    }

    async CreateWorkflowParamData(request: WorkflowParamCreateRequestList): Promise<WorkflowParamCreateResponse> {
        try {
            const endpoint = 'coredata/workflowparam/create';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.postRequest<boolean, WorkflowParamCreateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message || 'Success'
                };
            } else {
                throw new Error(response.data.message || 'Failed to create Workflow Parameter data');
            }
        } catch (error) {
            throw error;
        }
    }

    async UpdateWorkflowParamData(request: WorkflowParamUpdateRequestList): Promise<WorkflowParamUpdateResponse> {
        try {
            const endpoint = 'coredata/workflowparam/update-list';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.putRequest<boolean, WorkflowParamUpdateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message || 'Success'
                };
            } else {
                throw new Error(response.data.message || 'Failed to update Workflow Parameter data');
            }
        } catch (error) {
            throw error;
        }
    }

    async DeleteWorkflowParamData(id: string): Promise<WorkflowParamDeleteResponse> {
        try {
            const endpoint = `coredata/workflowparam/${id}`;
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.deleteRequest<boolean, void>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to delete Workflow Param data');
            }
        } catch (error) {
            throw error;
        }
    }

    async GetShipUnitSpecData(pageNumber: number, pageSize: number, partnerCode: string): Promise<ShipUnitSpecDataResponse> {
        try {
            const endpoint = `coredata/shipunitspec/getall?pageNumber=${pageNumber}&pageSize=${pageSize}&partnerCode=${partnerCode}`;
            const response: AxiosResponse<ApiResponse<ShipUnitSpecData>> = 
                await this.httpService.getRequest<ShipUnitSpecData>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message || 'Success'
                };
            } else {
                throw new Error(response.data.message || 'Failed to get Ship Unit Spec data');
            }
        } catch (error) {
            throw error;
        }
    }

    async CreateShipUnitSpecData(request: ShipUnitSpecCreateRequestList): Promise<ShipUnitSpecCreateResponse> {
        try {
            const endpoint = 'coredata/shipunitspec/create';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.postRequest<boolean, ShipUnitSpecCreateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message || 'Success'
                };
            } else {
                throw new Error(response.data.message || 'Failed to create Ship Unit Spec data');
            }
        } catch (error) {
            throw error;
        }
    }

    async UpdateShipUnitSpecData(request: ShipUnitSpecUpdateRequestList): Promise<ShipUnitSpecUpdateResponse> {
        try {
            const endpoint = 'coredata/shipunitspec/update-list';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.putRequest<boolean, ShipUnitSpecUpdateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message || 'Success'
                };
            } else {
                throw new Error(response.data.message || 'Failed to update Ship Unit Spec data');
            }
        } catch (error) {
            throw error;
        }
    }

    async DeleteShipUnitSpecData(id: string): Promise<ShipUnitSpecDeleteResponse> {
        try {
            const endpoint = `coredata/shipunitspec/${id}`;
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.deleteRequest<boolean, void>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to delete Ship Unit Spec data');
            }
        } catch (error) {
            throw error;
        }
    }

    async GetTextTemplateData(pageNumber: number, pageSize: number, partnerCode: string): Promise<TextTemplateDataResponse> {
        try {
            const response = await this.httpService.getRequest<TextTemplateData>(
                `coredata/texttemplate/getall?pageNumber=${pageNumber}&pageSize=${pageSize}&partnerCode=${partnerCode}`
            );
            return {
                isSuccess: response.data.isSuccess,
                data: response.data.data,
                message: response.data.message || 'Success'
            };
        } catch (error) {
            throw error;
        }
    }

    async CreateTextTemplateData(request: TextTemplateCreateRequestList): Promise<TextTemplateCreateResponse> {
        try {
            const response = await this.httpService.postRequest<boolean, TextTemplateCreateRequestList>(
                `coredata/texttemplate/create`,
                request
            );
            return {
                isSuccess: response.data.isSuccess,
                data: response.data.data,
                message: response.data.message || 'Success'
            };
        } catch (error) {
            throw error;
        }
    }

    async UpdateTextTemplateData(request: TextTemplateUpdateRequestList): Promise<TextTemplateUpdateResponse> {
        try {
            const endpoint = 'coredata/texttemplate/update-list';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.putRequest<boolean, TextTemplateUpdateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message || 'Success'
                };
            } else {
                throw new Error(response.data.message || 'Failed to update Text Template data');
            }
        } catch (error) {
            throw error;
        }
    }

    async DeleteTextTemplateData(request: TextTemplateDeleteRequest): Promise<TextTemplateDeleteResponse> {
        try {
            const response = await this.httpService.postRequest<boolean, TextTemplateDeleteRequest>(
                `coredata/texttemplate/delete`,
                request
            );
            return {
                isSuccess: response.data.isSuccess,
                data: response.data.data,
                message: response.data.message || 'Success'
            };
        } catch (error) {
            throw error;
        }
    }
    async GetOTMItineraryData(pageNumber: number, pageSize: number, partnerCode: string): Promise<OTMItineraryDataResponse> {
        try {
            const endpoint = `coredata/itinerary/getall?pageNumber=${pageNumber}&pageSize=${pageSize}&partnerCode=${partnerCode}`;
            const response: AxiosResponse<ApiResponse<OTMItineraryData>> = 
                await this.httpService.getRequest<OTMItineraryData>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to fetch OTM itinerary data');
            }
        } catch (error) {
            throw error;
        }
    }
    async CreateOTMItineraryData(request: OTMItineraryCreateRequestList): Promise<OTMItineraryCreateResponse> {
        try {
            const endpoint = 'coredata/itinerary/create';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.postRequest<boolean, OTMItineraryCreateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,    
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to create OTM contact data');
            }
        } catch (error) {
            throw error;
        }
    }

    async UpdateOTMItineraryData(request: OTMItineraryUpdateRequestList): Promise<OTMItineraryUpdateResponse> {
        try {
            const endpoint = 'coredata/itinerary/update-list';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.putRequest<boolean, OTMItineraryUpdateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message || 'Success'
                };
            } else {
                throw new Error(response.data.message || 'Failed to update OTM Itinerary data');
            }
        } catch (error) {
            throw error;
        }
    }

    async DeleteOTMItineraryData(id: string): Promise<OTMItineraryDeleteResponse> {
        try {
            const endpoint = `coredata/itinerary/${id}`;
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.deleteRequest<boolean, void>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to delete OTM itinerary data');
            }
        } catch (error) {
            throw error;
        }
    }

    async GetOTMItineraryDetailData(pageNumber: number, pageSize: number, partnerCode: string): Promise<OTMItineraryDetailDataResponse> {
        try {
            const endpoint = `coredata/itinerarydetail/getall?pageNumber=${pageNumber}&pageSize=${pageSize}&partnerCode=${partnerCode}`;
            const response: AxiosResponse<ApiResponse<OTMItineraryDetailData>> = 
                await this.httpService.getRequest<OTMItineraryDetailData>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to fetch OTM itinerary detail data');
            }
        } catch (error) {
            throw error;
        }
    }
    async CreateOTMItineraryDetailData(request: OTMItineraryDetailCreateRequestList): Promise<OTMItineraryDetailCreateResponse> {
        try {
            const endpoint = 'coredata/itinerarydetail/create';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.postRequest<boolean, OTMItineraryDetailCreateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to create OTM contact com method data');
            }
        } catch (error) {
            throw error;
        }
    }

    async UpdateOTMItineraryDetailData(request: OTMItineraryDetailUpdateRequestList): Promise<OTMItineraryDetailUpdateResponse> {
        try {
            const endpoint = 'coredata/itinerarydetail/update-list';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.putRequest<boolean, OTMItineraryDetailUpdateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message || 'Success'
                };
            } else {
                throw new Error(response.data.message || 'Failed to update OTM Itinerary Detail data');
            }
        } catch (error) {
            throw error;
        }
    }

    async DeleteOTMItineraryDetailData(id: string): Promise<OTMItineraryDetailDeleteResponse> {
        try {
            const endpoint = `coredata/itinerarydetail/${id}`;
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.deleteRequest<boolean, void>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to delete OTM itinerary detail data');
            }
        } catch (error) {
            throw error;
        }
    }
    async GetOTMItineraryLegData(pageNumber: number, pageSize: number, partnerCode: string): Promise<OTMItineraryLegDataResponse> {
        try {
            const endpoint = `coredata/leg/getall?pageNumber=${pageNumber}&pageSize=${pageSize}&partnerCode=${partnerCode}`;
            const response: AxiosResponse<ApiResponse<OTMItineraryLegData>> = 
                await this.httpService.getRequest<OTMItineraryLegData>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to fetch OTM leg data');
            }
        } catch (error) {
            throw error;
        }
    }
    async CreateOTMItineraryLegData(request: OTMItineraryLegCreateRequestList): Promise<OTMItineraryLegCreateResponse> {
        try {
            const endpoint = 'coredata/leg/create';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.postRequest<boolean, OTMItineraryLegCreateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,    
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to create OTM leg data');
            }
        } catch (error) {
            throw error;
        }
    }

    async UpdateOTMItineraryLegData(request: OTMItineraryLegUpdateRequestList): Promise<OTMItineraryLegUpdateResponse> {
        try {
            const endpoint = 'coredata/itineraryleg/update-list';
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.putRequest<boolean, OTMItineraryLegUpdateRequestList>(endpoint, request);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message || 'Success'
                };
            } else {
                throw new Error(response.data.message || 'Failed to update OTM Itinerary Leg data');
            }
        } catch (error) {
            throw error;
        }
    }

    async DeleteOTMItineraryLegData(id: string): Promise<OTMItineraryLegDeleteResponse> {
        try {
            const endpoint = `coredata/leg/${id}`;
            const response: AxiosResponse<ApiResponse<boolean>> = 
                await this.httpService.deleteRequest<boolean, void>(endpoint);
            
            if (isSuccessResponse(response.data)) {
                return {
                    isSuccess: true,
                    data: response.data.data,
                    message: response.data.message
                };
            } else {
                throw new Error(response.data.message || 'Failed to delete OTM itinerary leg data');
            }
        } catch (error) {
            throw error;
        }
    }


    // Add more core data entity methods here as needed

}
